import { useRecoilState } from "recoil";
import { modalState } from "../recoil/modal";
import { ReactNode, useCallback } from "react";

type OpenModalType = {
  type: "login" | "guide" | "";
  // string도 ReactNode의 부분 집합이라 기존 호출부 변경 없이 JSX 삽입 가능.
  message: ReactNode;
};

export const useModal = () => {
  const [modalDataState, setModalDataState] = useRecoilState(modalState);

  const closeModal = useCallback(() => {
    setModalDataState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, [setModalDataState]);

  const openModal = useCallback(
    ({ type, message }: OpenModalType) => {
      setModalDataState({ type: type, message: message, isOpen: true });
    },
    [setModalDataState]
  );

  return { modalDataState, closeModal, openModal };
};
